<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="確認"
  >
    <template v-slot:body="{ ok, cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <strong>
                こちらの内容でVN L2/L3コネクト設定を削除します。よろしいですか？
              </strong>
            </v-row>
            <div class="mt-3 ml-2">
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="VNコネクト名"
                    :value="vnL2L3ConnectDetail.vnConnectName"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="回線番号"
                    :value="vnL2L3ConnectDetail.enumber"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <app-label-group label="L2VN">
                    <template #value>
                      <div class="ml-3">
                        {{ vnL2L3ConnectDetail.l2VnName }}:{{
                          vnL2L3ConnectDetail.l2VnCode
                        }}({{
                          vnL2L3ConnectDetail.l2VnVlanIdType === "SPECIFIED"
                            ? vnL2L3ConnectDetail.l2VnVlanId
                            : vnL2L3ConnectDetail.l2VnVlanIdType === "OTHER"
                              ? "Other"
                              : "Untag"
                        }})
                      </div>
                    </template>
                  </app-label-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="L2/L3コネクト VLAN"
                    :value="
                      vnL2L3ConnectDetail.vnl2l3VlanIdType === 'SPECIFIED'
                        ? vnL2L3ConnectDetail.vnl2l3VnVlanId
                        : vnL2L3ConnectDetail.vnl2l3VlanIdType === 'OTHER'
                          ? 'Other'
                          : 'Untag'
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="L3VPN/VN"
                    :value="
                      vnL2L3ConnectDetail.l3VpnVnCode.charAt(0) === `B`
                        ? vnL2L3ConnectDetail.l3VpnVnCode
                        : vnL2L3ConnectDetail.l3VpnVnName +
                          ':' +
                          vnL2L3ConnectDetail.l3VpnVnCode
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="WANアドレス"
                    :value="vnL2L3ConnectDetail.wanAddress"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="ルーティング種別"
                    :value="
                      $filter.enumTo(
                        vnL2L3ConnectDetail.routingType,
                        'routingType'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <div v-if="vnL2L3ConnectDetail.routingType === 'BGP4'">
                <v-row>
                  <template
                    v-for="(item, index) in bgp4List"
                    :key="`peer${index}`"
                  >
                    <v-col cols="6">
                      <v-row class="mt-2">
                        <v-col>
                          <h3>
                            {{ $filter.enumTo(item.peerName, "peerName") }}
                          </h3>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="AS番号"
                            :value="item.asNumber"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="ピアIPアドレス"
                            :value="item.peerIpAddress"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="MD5キー"
                            :value="$filter.emptyTo(item.md5Key, '-')"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="Maximum Prefix"
                            :value="item.maximumPrefix"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="Local Preference"
                            :value="
                              $filter.enumTo(
                                item.localPreference,
                                'localPreference'
                              )
                            "
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="MED"
                            :value="$filter.enumTo(item.med, 'med')"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="経路集約"
                            :value="
                              $filter.enumTo(item.isRouteAggregation, 'on_off')
                            "
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                  </template>
                </v-row>
              </div>
              <div v-else-if="vnL2L3ConnectDetail.routingType === 'STATIC'">
                <v-row>
                  <v-col cols="12">
                    <app-label-group label="経路" />
                  </v-col>
                </v-row>
                <div class="ml-2">
                  <v-row>
                    <v-col cols="6">
                      <app-label-group label="LANアドレス">
                        <template #value>
                          <div class="pl-4">
                            <template
                              v-if="vnL2L3ConnectDetail.static.length > 0"
                            >
                              <div
                                v-for="(lan, index) in sortedStaticByLanAddress"
                                :key="index"
                              >
                                {{ lan.lanAddress }}
                              </div>
                            </template>
                            <template v-else>-</template>
                          </div>
                        </template>
                      </app-label-group>
                    </v-col>
                    <v-col cols="6">
                      <app-label-group label="ネクストホップアドレス">
                        <template #value>
                          <div class="pl-4">
                            <template
                              v-if="vnL2L3ConnectDetail.static.length > 0"
                            >
                              <div
                                v-for="(lan, index) in sortedStaticByLanAddress"
                                :key="index"
                              >
                                {{ lan.nextHopAddress }}
                              </div>
                            </template>
                            <template v-else>-</template>
                          </div>
                        </template>
                      </app-label-group>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <div v-else-if="vnL2L3ConnectDetail.routingType === 'OSPF'">
                <v-row>
                  <v-col cols="12">
                    <app-label-group
                      label="エリア番号"
                      :value="vnL2L3ConnectDetail.ospf!.areaNumber"
                    />
                  </v-col>
                </v-row>
              </div>
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="備考"
                    :value="
                      $filter.emptyTo(vnL2L3ConnectDetail.description, '-')
                    "
                  />
                </v-col>
              </v-row>
            </div>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="ok" variant="flat" color="primary">はい</v-btn>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { Bgp4Peer, VNL2L3ConnectDetail } from "@/apis/VNL2L3ConnectApi";
import sortCompare from "@/services/SortService";

export default defineComponent({
  name: "VNL2L3ConnectDelete",
  props: {
    vnL2L3ConnectDetail: {
      type: Object as PropType<VNL2L3ConnectDetail>,
      required: true,
    },
  },
  computed: {
    bgp4List(): Bgp4Peer[] {
      if (this.vnL2L3ConnectDetail.routingType === "BGP4") {
        return this.vnL2L3ConnectDetail.bgp4!.sortBy(["peerName", "asc"]);
      } else {
        return [];
      }
    },
    /** LANアドレスで昇順ソートしたstatic配列 */
    sortedStaticByLanAddress(): VNL2L3ConnectDetail["static"] {
      const statics = this.vnL2L3ConnectDetail.static || [];
      return [...statics].sort((a, b) =>
        sortCompare(a, b, [["lanAddress", "asc"]])
      );
    },
  },
});
</script>
